<template>
  <div class="food-search-dialog">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item align="right">
          <md-icon
            style="cursor: pointer"
            slot="default"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-flexbox-item style="padding: 16px" class="subHeader">
      <div>Select one of your pre-saved meals from the list</div>
    </mu-flexbox-item>
    <div class="scrollable-area">

      <transition name="fade" mode="in-out">
        <mu-flexbox v-if="isLoading" align="center" justify="center" style="height: 100%">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="24"></mu-circular-progress>
            <br/>
            <span v-text="$t('message.savingText')"></span>
          </mu-flexbox-item>
        </mu-flexbox>
      </transition>

      <mu-list class="oddEven" v-if="!isLoading">
        <mu-list-item
          disableRipple
          v-for="meal, index in meals"
          :key="meal.meal_id"
          @click="loadFoods"

        >
          <div slot="title" v-once @click="loadMeal(meal)">{{meal.meal_name}}</div>
          <div slot="describe" @click="loadMeal(meal)">
            Contains {{meal.count}} foods
          </div>

          <mu-icon-menu slot="right" icon="more_vert" :scroller="scroller">
            <mu-menu-item :title="$t('message.deleteText')" @click.native="deleteMeal(meal.meal_id)"/>
          </mu-icon-menu>


        </mu-list-item>
      </mu-list>
    </div>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food';
  import {Observable} from 'rxjs';
  import MuFlexboxItem from "muse-ui/src/flexbox/flexboxItem";
  import MuListItem from "muse-ui/src/list/listItem";
  import scrollerMixin from '../../../mixins/ScrollerMixin'

  export default {
    mixins: [scrollerMixin],
    components: {
      MuListItem,
      MuFlexboxItem
    },
    name: 'fd-mymeals-dialog',
    props: {
      title: {
        type: String,
        default: ""
      },
      mealTypeId: {
        type: Number,
        default: 0
      },
      date: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        isLoading: false,
        meals: {}

      }
    },
    mounted() {
      let self = this
      FoodApi.getFavorites()
        .then(function (response) {
          self.meals = response.data;
        });
      self.initScrollFix();
      $(window).resize(function () {
        self.initScrollFix();
      });
    },
    methods: {
      loadMeal(meal) {
        let self = this;

       let date =  moment(self.date)
        if(self.mealTypeId === 1) {
          date.set({
            'hour': 9,
            'minute': 0,
            'second': 0
          })
        }

        if(self.mealTypeId === 2) {
         date.set({
           'hour': 12,
           'minute': 0,
           'second': 0
         })
        }

        if(self.mealTypeId === 3) {
         date.set({
           'hour': 18,
           'minute': 0,
           'second': 0
         })
        }
        self.isLoading = true;

        FoodApi.addFoods({
          date: date.format(),
          meal_type_id: self.mealTypeId,
          foods: meal.foods,
          recipes: meal.recipes
        })
          .then(function (response) {
            self.$toastr.success(self.$t('message.labelSuccess'));
            self.$router.replace({
              name: 'FoodDiary',
              query: {
                date: moment(self.date).format('YYYY-MM-DD')
              }
            });
            self.$emit('closeDialogAndReload');
          })
          .catch(function () {
            self.isLoading = false;
          })
      },
      deleteMeal(mealId) {
        let self = this;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return FoodApi.deleteFavorite(mealId)
          }
        })
          .then(function () {
            const index = self.meals.findIndex(obj => obj.meal_id === mealId);
            if (index !== -1) self.meals.splice(index, 1);
            self.$toastr.success(self.$t('message.foodDiaryMealPlateRemoved'))
          })


      },
      initScrollFix() {
        let headerHeight = $('.add-food-dialog .blueHeader').outerHeight();
        let searchHeight = $('.add-food-dialog .subHeader').outerHeight();
        let panelHeight = $('.add-food-dialog').outerHeight();
        let scrollHeight = panelHeight - (searchHeight + headerHeight);
        $('.food-search-dialog .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
      },

      closeDialog() {
        this.$emit('closeDialog')
      }
    }
  }
</script>
<style>

  .load-wrapp {
    width: auto !important;
    height: auto !important;
    text-align: center;
  }

  .load-wrapp p {
    padding: 0 0 20px;
  }

  .load-wrapp:last-child {
    margin-right: 0;
  }

  .load-3 .line:nth-last-child(1) {
    animation: loadingC .6s .1s linear infinite;
  }

  .load-3 .line:nth-last-child(2) {
    animation: loadingC .6s .2s linear infinite;
  }

  .load-3 .line:nth-last-child(3) {
    animation: loadingC .6s .3s linear infinite;
  }

  .load-wrapp .line {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
  }

  .loaderRed {
    background: #F58923 !important;
  }

  .loaderGreen {
    background: #7CBE30 !important;
  }

  .loaderBlue {
    background: #0179d5 !important;
  }

  @keyframes loadingC {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(0, 15px);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .food-search-dialog .scrollable-area {
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .food-search-dialog .mu-paper .mu-text-field-content {
    padding-top: 8px;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .food-search-dialog .mu-paper .mu-text-field {
    min-height: initial;
  }

  .food-search-dialog .search-area {
    padding-left: 0px;
    padding-right: 16px;
    margin-top: -8px;
    margin-left: -8px;
    margin-right: -8px;
  }

  .add-food-dialog .labelBelowImg {
    margin-top: 8px;
    font-weight: 400;
  }

  @media (min-width: 993px) {
    .add-food-dialog .row .desktop-50 {
      width: calc((100% - 24px * 1) / 2) !important;
    }
  }

  .add-food-dialog .highlight {
    font-weight: 500;
    color: #0179d5;
  }

  .removePadding .mu-card-header-title {
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// MyMeals.vue?f0829760